import { formatDuration, intervalToDuration } from "date-fns";

export const minutesToHoursToDaysExtended = (minutes?: number) => {
  const durations = minutes ? intervalToDuration({ start: 0, end: minutes * 60000 }) : undefined;
  return durations ? formatDuration(durations) : "";
};